export const ORDER_STATUSES = {
  READY_FOR_PROCESSING: 'READY_FOR_PROCESSING',
  DESIGNATED_FOR_PROCESSING_AT_HUB: 'DESIGNATED_FOR_PROCESSING_AT_HUB',
  PROCESSING: 'PROCESSING',
  DROPPED_OFF_AT_HUB: 'DROPPED_OFF_AT_HUB',
  IN_TRANSIT_TO_HUB: 'IN_TRANSIT_TO_HUB',
  RECEIVED_AT_HUB_FOR_PROCESSING: 'RECEIVED_AT_HUB_FOR_PROCESSING',
  READY_FOR_PICKUP: 'READY_FOR_PICKUP',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED',
  EN_ROUTE_TO_CUSTOMER: 'EN_ROUTE_TO_CUSTOMER',
  READY_FOR_DRIVER_PICKUP: 'READY_FOR_DRIVER_PICKUP',
  HUB_PROCESSING_ORDER: 'HUB_PROCESSING_ORDER',
  HUB_PROCESSING_COMPLETE: 'HUB_PROCESSING_COMPLETE',
  IN_TRANSIT_TO_STORE: 'IN_TRANSIT_TO_STORE',
  READY_FOR_INTAKE: 'READY_FOR_INTAKE',
  SUBMITTED: 'SUBMITTED',
  DROPPED_OFF_AT_STORE: 'DROPPED_OFF_AT_STORE',
  PAYMENT_REQUIRED: 'PAYMENT_REQUIRED',
};

/** Activity-log-only statuses; these never appear in `serviceOrders.status`. */
export const ACTIVITY_LOG_DELIVERY_STATUSES = {
  PICKUP_RESCHEDULED: 'PICKUP_RESCHEDULED',
  DELIVERY_RESCHEDULED: 'DELIVERY_RESCHEDULED',
  DELIVERY_CANCELED: 'DELIVERY_CANCELED',
  MISSED_PICKUP: 'MISSED_PICKUP',
};

export const PAYMENT_PROCESSOR = {
  STRIPE: 'stripe',
  CASH: 'cash',
};

export const PAYMENT_STATUSES = {
  SUCCEEDED: 'succeeded',
};

export const serviceOrderStatuses = [
  { display: 'READY_FOR_PROCESSING', value: 'READY_FOR_PROCESSING' },
  { display: 'DESIGNATED_FOR_PROCESSING_AT_HUB', value: 'DESIGNATED_FOR_PROCESSING_AT_HUB' },
  { display: 'PROCESSING', value: 'PROCESSING' },
  { display: 'DROPPED_OFF_AT_HUB', value: 'DROPPED_OFF_AT_HUB' },
  { display: 'IN_TRANSIT_TO_HUB', value: 'IN_TRANSIT_TO_HUB' },
  { display: 'RECEIVED_AT_HUB_FOR_PROCESSING', value: 'RECEIVED_AT_HUB_FOR_PROCESSING' },
  { display: 'READY_FOR_PICKUP', value: 'READY_FOR_PICKUP' },
  { display: 'COMPLETED', value: 'COMPLETED' },
  { display: 'CANCELED', value: 'CANCELLED' },
  { display: 'EN_ROUTE_TO_CUSTOMER', value: 'EN_ROUTE_TO_CUSTOMER' },
  { display: 'READY_FOR_DRIVER_PICKUP', value: 'READY_FOR_DRIVER_PICKUP' },
  { display: 'HUB_PROCESSING_ORDER', value: 'HUB_PROCESSING_ORDER' },
  { display: 'HUB_PROCESSING_COMPLETE', value: 'HUB_PROCESSING_COMPLETE' },
  { display: 'IN_TRANSIT_TO_STORE', value: 'IN_TRANSIT_TO_STORE' },
  { display: 'READY_FOR_INTAKE', value: 'READY_FOR_INTAKE' },
  { display: 'SUBMITTED', value: 'SUBMITTED' },
];

export const inventoryOrderStatuses = [
  { display: 'CREATED', value: 'CREATED' },
  { display: 'COMPLETED', value: 'COMPLETED' },
  { display: 'CANCELLED', value: 'CANCELLED' },
];

export const orderDeliveryStatuses = [
  { display: 'SCHEDULED', value: 'SCHEDULED' },
  { display: 'EN_ROUTE_TO_PICKUP', value: 'EN_ROUTE_TO_PICKUP' },
  { display: 'EN_ROUTE_TO_DROP_OFF', value: 'EN_ROUTE_TO_DROP_OFF' },
  { display: 'COMPLETED', value: 'COMPLETED' },
  { display: 'CANCELED', value: 'CANCELED' },
  { display: 'FAILED', value: 'FAILED' },
  { display: 'INTENT_CREATED', value: 'INTENT_CREATED' },
];

export const onPremisePaymentProviders = [
  { display: 'Stripe', value: 'STRIPE' },
  { display: 'Adyen', value: 'ADYEN' },
];

export const onPremiseConnectivityMethods = [
  { display: 'Local Network', value: 'LOCAL_NETWORK' },
  { display: 'Server Driven', value: 'SERVER_DRIVEN' },
];

export const THEME_RADIUS_INDICATOR = {
  squared: 'Squared',
  rounded: 'Rounded',
};

export const THEME_ELEMENTS = {
  primaryColorCheap: 'Primary color',
  url: 'Url',
  businessLabel: 'Business theme',
  link: 'Link:',
  name: 'Name',
  storeNames: 'Stores use',
  themesList: 'Themes list:',
};

export const THEME_MESSAGES = {
  areYouShoreToDelete: 'Are you sure you want to delete this theme?',
  successfullyDeleted: 'Theme deleted successfully!',
  somethingWrong: 'Oops, something went wrong!',
  editTitle: 'Edit business themes',
  commonThemeUpdated: `Common theme was updated!`,
};

export const BUTTONS = {
  yes: 'Yes',
  save: 'Save',
  cancel: 'Cancel',
  no: 'No',
  edit: 'Edit',
  impersonate: 'Impersonate',
  activate: 'Activate',
  liveLink: 'LiveLink',
  set: 'Set',
  delete: 'Delete',
  createNew: 'Create new theme',
  setTheme: 'Set theme',
  color: 'Color',
  themeList: 'Themes list',
  copyLiveLinkUrl: 'Copy Live Link URL',
};

export const THEME_VALUES = {
  defaultPrimaryColor: '#3D98FF',
  squaredRadius: '0px',
  roundedRadius: '31px',
  defaultLogo: 'https://cents-product-images.s3.us-east-2.amazonaws.com/Cents+LOGO.png',
  defaultColors: [
    '#0567d5',
    '#0c73e9',
    '#c05701',
    '#181818',
    '#3a7f2e',
    '#384fb2',
    '#291069',
    '#b30000',
    '#6a016e',
    '#016060',
    '#6626a7',
    '#ad0045',
    '#0a244a',
  ],
};

export const BUSINESS_MODAL_TYPES = {
  type: 'Type',
  messengerConfiguration: 'messengerConfiguration',
  integrationsConfigs: 'integrationsConfigs',
};

export const MODAL_THEME = {
  height: '500px',
};

export const DEFAULT_THEME = {
  primaryColor: THEME_VALUES.defaultPrimaryColor,
  borderRadius: THEME_VALUES.roundedRadius,
  logoUrl: THEME_VALUES.defaultLogo,
};

export const THEME_TYPES = {
  store: 'store',
  business: 'business',
  common: 'common',
};

export const BUSINESS_TYPE_VALUES = {
  LIVE: 'LIVE',
  TEST: 'TEST',
  CHURN: 'CHURN',
};

export const businessTypes = [
  { display: 'Live', value: BUSINESS_TYPE_VALUES.LIVE },
  { display: 'Test', value: BUSINESS_TYPE_VALUES.TEST },
  { display: 'Churn', value: BUSINESS_TYPE_VALUES.CHURN },
];

export const USA_STATE_LIST = [
  'Alabama',
  'Alaska',
  'American Samoa',
  'Arizona',
  'Arkansas',
  'California',
  'Colorado',
  'Connecticut',
  'Delaware',
  'District Of Columbia',
  'Federated States Of Micronesia',
  'Florida',
  'Georgia',
  'Guam',
  'Hawaii',
  'Idaho',
  'Illinois',
  'Indiana',
  'Iowa',
  'Kansas',
  'Kentucky',
  'Louisiana',
  'Maine',
  'Marshall Islands',
  'Maryland',
  'Massachusetts',
  'Michigan',
  'Minnesota',
  'Mississippi',
  'Missouri',
  'Montana',
  'Nebraska',
  'Nevada',
  'New Hampshire',
  'New Jersey',
  'New Mexico',
  'New York',
  'North Carolina',
  'North Dakota',
  'Northern Mariana Islands',
  'Ohio',
  'Oklahoma',
  'Oregon',
  'Palau',
  'Pennsylvania',
  'Puerto Rico',
  'Rhode Island',
  'South Carolina',
  'South Dakota',
  'Tennessee',
  'Texas',
  'Utah',
  'Vermont',
  'Virgin Islands',
  'Virginia',
  'Washington',
  'West Virginia',
  'Wisconsin',
  'Wyoming',
];

export enum MACHINE_MANUFACTURERS {
  ALLIANCE_ACA = 'ALLIANCE-ACA',
  ALLIANCE_MIDAS = 'ALLIANCE-MIDAS',
  ALLIANCE_CENT = 'ALLIANCE-CENT',
  ALLIANCE_MDC = 'ALLIANCE-MDC',
  ALLIANCE_PULSE = 'ALLIANCE-PULSE',
  DEXTER = 'DEXTER',
  ELECTROLUX = 'ELECTROLUX',
}

export enum DEVICE_CONFIG_STATUSES {
  NOT_CONFIGURED = 'NOT_CONFIGURED',
  PENDING_CONFIG = 'PENDING_CONFIG',
  CONFIGURED = 'CONFIGURED',
}

export enum CYCLE_MODES {
  IDLE = 'IDLE',
  START = 'START',
  RUNNING = 'RUNNING',
  COMPLETE = 'COMPLETE',
}

export const DEFAULT_PAGE_LIMIT = 20;
